import React, { useEffect, useState } from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import RefIdForm from './components/RefIdForm';
import AggregateForm from './components/AggregateForm';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
  },
});

function BasicRouter() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const onLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('navigate', onLocationChange);
    return () => window.removeEventListener('navigate', onLocationChange);
  }, []);

  return (
    <>
      {(currentPath === '/' || currentPath === '/pdfExtractorHttp') && <RefIdForm />}
      {(currentPath === '/extract' ||  currentPath === '/pdfExtractorHttp/extract') && <AggregateForm />}
    </>
  )
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BasicRouter />
    </ThemeProvider>
  );
}

export default App;
